export const blockIconsImageAddPhotoAlternate = (
	<span className='material-symbols-outlined'>add_photo_alternate</span>
);
